<template>
    <div>
        <div class="ret1-1">核销回收</div>
        <div class="ret1-2">
            <div class="ret1">
                <img class="ret3" src="../../assets/imgs/07.png" alt="">
                <input type="text" v-model="keys" placeholder="请输入关键字进行搜索" class="ret2">
            </div>
            <div class="ret4" @click="lookFor">查找订单回收</div>
        </div>
        <div class="ret5">
            <div class="ret6">用户信息</div>
            <div class="ret7">
                <div class="ret7-1">用户名称：{{order.username}}</div>
                <div class="ret7-1">订单编号：{{order.code}}</div>
                <div class="ret7-1">领取方式：{{order.paytypeid}}</div>
            </div>
            <div class="ret7">
                <div class="ret7-1">用户编号：{{order.usercode}}</div>
                <div class="ret7-1">三方单号：{{order.paycode}}</div>
                <div class="ret7-1">状态：{{order.state}}</div>
            </div>
            <div class="ret7">
                <div class="ret7-1">领取时间：{{order.ctime}}</div>
                <div class="ret7-1"></div>
                <div class="ret7-1"></div>
            </div>
        </div>
        <div class="ret8">
            <div class="ret6">领取刀具信息表</div>
            <div class="ret9">
                <Table border ref="selection" :columns="columns7" :data="detail" :loading="loading">
                    <template slot-scope="{ row,index }" slot="action">
                        <Button size="small" style="margin-right: 5px;border: none;color: #7AD1F9;" @click="shezhi(row,index)">设置数量</Button> 
                    </template>
                </Table>
            </div>
        </div>
        <div class="ret10" style="border-bottom: none;margin-top: 5px;">
            <Page :total="total" :page-size="7" @on-change="toPage"/>
        </div>
        <div class="ret17">
            <div class="ret17-1" @click="qingchu">清除重输</div>
            <div @click="confires" class="ret17-2">确认归还</div>
        </div>
        <!-- 归还数量 -->
        <xc-model :loading="guiHuanModel" title="归还数量" :is_buttom="false" @cancel="qx">
            <div slot="mbody">
                <div class="ret11">
                    <div class="ret12">
                        <div class="ret13">归还数量：</div>
                        <input v-model="numbers" type="number" placeholder="请输入需要归还的数量" class="ret14">
                    </div>
                    <div class="ret15">
                        <div class="ret16" @click="knows">确认</div>
                        <div class="ret16" style="margin-left: 50px" @click="qx">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 归还确定 -->
        <xc-model :loading="guiHuanSure" title="归还确定" :is_buttom="false" @cancel="cancels">
            <div slot="mbody">
                <div class="ret11">
                    <div class="ret12">
                        <div class="ret13">您确定要将这些刀具进行回收吗？</div>
                    </div>
                    <div class="ret15">
                        <div class="ret16" @click="sure">确认</div>
                        <div class="ret16" style="margin-left: 50px" @click="cancels">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
    </div>
</template>

<script>
import https from '@/api/retrieve'
    export default {
        inject: ["reload"],
        data(){
            return{
                keys:'',
                user:'',
                numbers:'',
                numbers1:'',
                guiHuanModel:false,
                guiHuanSure:false,
                total:0,
                columns7:[
                {
                    title: '刀具名称',
                    width: 200,
                    align: 'center',
                    key: 'goodsname'
                },
                {
                    title: '刀具编码',
                    width: 200,
                    align: 'center',
                    key: 'goodscode'
                },
                {
                    title: '加工产品名称',
                    width: 200,
                    align: 'center',
                    key: 'productname'
                },
                {
                    title: '组织架构',
                    width: 200,
                    align: 'center',
                    key: 'orgname'
                },
                {
                    title: '工序名称',
                    width: 200,
                    align: 'center',
                    key: 'procedurename'
                },
                {
                    title: '刀具型号',
                    width: 200,
                    align: 'center',
                    key: 'goodsmodel'
                },
                {
                    title: '单位',
                    width: 200,
                    align: 'center',
                    key: 'goodsunit'
                },
                {
                    title: '未归还数量',
                    width: 200,
                    align: 'center',
                    key: 'notreturnnum'
                },
                {
                    title: '需要归还的数量',
                    width: 150,
                    align: 'center',
                    key: 'needreturnnum'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 150,
                    align: 'center'
                }
                ],
                order:{},
                detail:[],
                canList:[],
                dingDanId:'',
                loading:false,
                page:1,
                pageSize:7,
                indexs:''
            }
        },
        mounted(){
            this.user = JSON.parse(sessionStorage.getItem('user'));
        },
        methods:{
            // 通过订单号查询订单
            lookFor(){
                // this.loading = true
                if(this.keys == ''){
                    this.$message.error('请输入订单号');
                    return false;
                }
                let data = {
                    page:this.page,
                    pageSize:this.pageSize,
                    orderid:this.keys,
                    // orderid:'07781643a86d4721a612aba6a01cf8b1',
                    companyid:this.user.companyId
                    // companyid:'f08b7e4d42bb45a08e3532a78567d00e'
                };
                https.findorderbyid(data).then(res=>{
                    if(res.data.dataList.order.paytypeid == 1) {
                        res.data.dataList.order.paytypeid = '支付宝'
                    }else if(res.data.dataList.order.paytypeid == 2){
                        res.data.dataList.order.paytypeid = '微信'
                    }else{
                        res.data.dataList.order.paytypeid = '刷卡'
                    }
                    if(res.data.dataList.order.state == 1){
                        res.data.dataList.order.state = '正常'
                    }else if(res.data.dataList.order.state == 2){
                        res.data.dataList.order.state = '出货异常'
                    }else if(res.data.dataList.order.state == 3){
                        res.data.dataList.order.state = '待出货'
                    }else{
                        res.data.dataList.order.state = '取消'
                    }
                    this.order = res.data.dataList.order
                    this.dingDanId = res.data.dataList.order.id
                    this.detail = res.data.dataList.detail
                    this.total = res.data.totalNum
                    this.loading = false
                })
            },
            toPage(e){
                this.loading = true
                let data = {
                    page:e,
                    pageSize:this.pageSize,
                    orderid:this.keys,
                    // orderid:'07781643a86d4721a612aba6a01cf8b1',
                    // companyid:this.user.companyId
                    companyid:'f08b7e4d42bb45a08e3532a78567d00e'
                };
                https.findorderbyid(data).then(res=>{
                    if(res.data.dataList.order.paytypeid == 1) {
                        res.data.dataList.order.paytypeid = '支付宝'
                    }else if(res.data.dataList.order.paytypeid == 2){
                        res.data.dataList.order.paytypeid = '微信'
                    }else{
                        res.data.dataList.order.paytypeid = '刷卡'
                    }
                    if(res.data.dataList.order.state == 1){
                        res.data.dataList.order.state = '正常'
                    }else if(res.data.dataList.order.state == 2){
                        res.data.dataList.order.state = '出货异常'
                    }else if(res.data.dataList.order.state == 3){
                        res.data.dataList.order.state = '待出货'
                    }else{
                        res.data.dataList.order.state = '取消'
                    }
                    this.order = res.data.dataList.order
                    this.dingDanId = res.data.dataList.order.id
                    this.detail = res.data.dataList.detail
                    this.total = res.data.totalNum
                    this.loading = false
                })
            },
            shezhi(row,index){
                this.indexs = index
                this.guiHuanModel = true
                this.numbers1 = this.detail[index]
                console.log(this.numbers1,'this.numbers1')
                this.numbers = ''
                // this.canList = []
                // console.log(this.numbers1,'this.numbers1')
            },
            knows(){
                this.$set(this.numbers1,'needreturnnum',this.numbers)
                let data = {
                    id:'',
                    goodsid:'',
                    num:'',
                    price:'',
                    totalprice:'',
                    detailid:''
                }
                data.id = this.numbers1.id
                data.goodsid = this.numbers1.goodsid
                data.num = this.numbers1.needreturnnum
                data.price = this.numbers1.price
                data.totalprice = this.numbers1.totalprice
                data.detailid = this.numbers1.detailid

                // this.canList.push(data)
                if(!this.canList.map(v=>v.id).includes(data.id)){
                    this.canList.push(data)
                }
                this.canList = this.canList.map((v,inx)=>{
                    if(data.id==v.id){
                        v=data
                    }
                    return v
                })
                console.log(this.canList,'this.canList')
                this.guiHuanModel = false
            },
            qx(){
                this.guiHuanModel = false
            },
            sure(){
                let data = {
                    id:this.dingDanId,
                    details:this.canList
                }
                https.addorderbyorderid(data).then(res=>{
                    if(res.code == '0000'){
                        this.$message.success('回收成功');
                        this.guiHuanSure = false
                        setTimeout(() => {
                            this.reload();
                        }, 500);
                    }else if(res.code == '1002'){
                        this.$message.error('归还内容为空');
                    }else if(res.code == '1111'){
                        this.$message.error('归还内容大于未归还');
                    }
                })
            },
            cancels(){
                this.guiHuanSure = false
            },
            confires(){
                this.guiHuanSure = true
            },
            qingchu(){
                if(this.canList.length == 0) {
                    this.$message.info('你还没有修改值')
                }else {
                    this.canList = []
                    this.$message.success('清除成功,请重新修改')
                    this.lookFor()
                }
                // setTimeout(() => {
                //     this.reload();
                // }, 500);
            }
        }
    }
</script>

<style scoped>
@import "retrieve.css";
</style>